import { useState } from 'react'

import { BRACKET_NAME } from 'types/deck'

import { useActionless, useAppSelector } from 'redux/hooks'
import { selectCalculatedEDHBracket } from 'redux/deck/selectors'
import { TOGGLE_MODAL } from 'redux/active/actions/types'

import Icon from 'components/elements/Icon'
import EstimatedBracketOverlayContent from 'components/deckPage/header/calculatedBracketInfo/EstimatedBracketOverlayContent'
import GlobalOverlayStack from 'components/elements/Overlay/GlobalOverlayStack'
import { BracketBlurbs } from 'components/misc/BracketInfoToolTip'

import styles from './bracketPrompt.module.scss'

const BracketPrompt = () => {
  const [bracketDetailsOpen, setBracketDetailsOpen] = useState(false)

  const edhBracket = useAppSelector(state => state.deck.edhBracket)
  const calculatedBracket = useAppSelector(selectCalculatedEDHBracket)

  const [toggleModal] = useActionless(TOGGLE_MODAL)

  let BracketBlurb = BracketBlurbs.BracketOne

  if (calculatedBracket === 2) BracketBlurb = BracketBlurbs.BracketTwo
  if (calculatedBracket === 3) BracketBlurb = BracketBlurbs.BracketThree
  if (calculatedBracket === 4) BracketBlurb = BracketBlurbs.BracketFour

  const bracketName = BRACKET_NAME[calculatedBracket]

  return (
    <>
      <div className={styles.container}>
        <button className={styles.estimatedBracketInfoTrigger} onClick={() => setBracketDetailsOpen(true)}>
          {!edhBracket && 'Est'} Commander Bracket: {edhBracket ? BRACKET_NAME[edhBracket] : bracketName}
        </button>
        <button className={styles.settingButton} onClick={() => toggleModal({ modalName: 'deckSettings', flag: true })}>
          <Icon name="cog" />
        </button>
      </div>

      <GlobalOverlayStack open={bracketDetailsOpen} onClose={() => setBracketDetailsOpen(false)}>
        <EstimatedBracketOverlayContent onForceClose={() => setBracketDetailsOpen(false)} />
      </GlobalOverlayStack>
    </>
  )
}

export default BracketPrompt
